import React from 'react';
import { ArrowRightIcon, PlusIcon, CheckIcon } from 'lucide-react';
export const CHECKOUT_KIT = 'https://checkout.aula-mater.online/cart/67383246913581:1';
export const CHECKOUT_PREMIUM = 'https://checkout.aula-mater.online/cart/67383279288365:1';
export function PremiumUpsellCTA() {
  return <div className="mt-8 border-t border-line pt-8" data-id="element-237" data-mp="1p4bmswvi1cgh">
      <div className="text-center mb-5" data-id="element-238" data-mp="1p6xt6t6nllx4">
        <div className="inline-flex items-center gap-2 bg-gold/10 text-gold px-3 py-1 rounded-full mb-3" data-id="element-239" data-mp="2342u6erifuli">
          <span className="text-[11px] font-bold tracking-widest" data-id="element-240" data-mp="1y6b5ruq2qqm2">
            ⭐ KIT PREMIUM
          </span>
        </div>
        <h3 className="font-serif font-bold text-xl md:text-2xl text-ink uppercase tracking-tight leading-tight" data-id="element-241" data-mp="2ct4dadtcqs3p">
          Kit completo{' '}
          <span className="font-serif-italic text-gold font-normal normal-case" data-id="element-242" data-mp="2lv3sd0kt3m40">
            + Cómo Trabajar con Gente Complicada
          </span>
        </h3>
      </div>

      <div className="flex justify-center mb-5" data-id="element-243" data-mp="2gxu7ly8d3ymi">
        <img src="https://cdn.magicpatterns.com/uploads/uFaVXZYMtvg3rzi9oZHkar/gente_complicada_mas_kit_antiestres.png" alt="Kit Antiestrés para el Trabajo + Cómo Trabajar con Gente Complicada" className="h-44 md:h-56 w-auto object-contain drop-shadow-xl" data-id="element-244" data-mp="2ro04gxcpbexi" />
      </div>

      <div className="bg-bg-warm border border-line rounded-2xl p-5 md:p-6 mb-6" data-id="element-245" data-mp="36l0zb9q6vq07">
        <ul className="space-y-2.5" data-id="element-246" data-mp="3amm56b4b340w">
          <li className="flex items-start gap-3 text-sm" data-id="element-247" data-mp="3alkwueeocvmv">
            <span className="flex-shrink-0 w-5 h-5 rounded-full bg-rose/15 flex items-center justify-center mt-0.5" data-id="element-248" data-mp="3fl5w6pxrb604">
              <CheckIcon className="w-3 h-3 text-rose" strokeWidth={3} data-id="element-249" data-mp="3kbw16229t6ua" />
            </span>
            <span className="text-ink" data-id="element-250" data-mp="3pbs3lwvbkq7q">
              Todo el Kit Antiestrés (4 materiales + 2 materiales premium ·
              +60 páginas)
            </span>
          </li>
          <li className="flex items-start gap-3 text-sm" data-id="element-251" data-mp="26j10fcejxhb">
            <span className="flex-shrink-0 w-5 h-5 rounded-full bg-gold/15 flex items-center justify-center mt-0.5" data-id="element-252" data-mp="272gzqihsbsp">
              <PlusIcon className="w-3 h-3 text-gold" strokeWidth={3} data-id="element-253" data-mp="1z52ocsb7pgby" />
            </span>
            <span className="text-ink" data-id="element-254" data-mp="1u9x2ftht81nv">
              <strong data-id="element-255" data-mp="27z8pkznvvfia">Cómo Trabajar con Gente Complicada</strong> — la guía
              completa para manejar personas difíciles sin perder tu calma ni tu
              energía mental.
            </span>
          </li>
        </ul>
      </div>

      <div className="flex items-baseline justify-center gap-2 flex-wrap mb-5" data-id="element-256" data-mp="2hwdfnakunv4d">
        <span className="font-serif font-bold text-4xl md:text-5xl text-gold" data-id="element-257" data-mp="2cxijl6xvga2b">
          $29.990
        </span>
        <span className="text-base text-ink-soft" data-id="element-258" data-mp="2qx1si1yibpfo">ARS</span>
        <span className="text-sm text-muted w-full text-center mt-1" data-id="element-259" data-mp="2mx12dk21ppss">
          Pago único · Acceso de por vida
        </span>
      </div>

      <a href={CHECKOUT_PREMIUM} target="_blank" rel="noopener noreferrer" onClick={() => {
      if (typeof window !== 'undefined' && (window as any).fbq) {
        ;
        (window as any).fbq('track', 'InitiateCheckout');
      }
    }} className="flex items-center justify-center gap-2 w-full bg-gold hover:bg-ink text-white font-bold text-base md:text-lg py-5 rounded-full text-center shadow-xl shadow-gold/20 hover:-translate-y-0.5 transition-all" data-id="element-260" data-mp="wl3ivywacrj9">
        <ArrowRightIcon className="w-5 h-5" data-id="element-261" data-mp="dmihn1mfyr7b" />
        QUIERO EL KIT PREMIUM
      </a>
    </div>;
}